import React, { useId } from 'react'

interface PaymentErrorIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Circular error icon used on payment failure screens.
 */
const PaymentErrorIcon: React.FC<PaymentErrorIconProps> = ({
  size = 88,
  color = '#DF4242',
  className,
}) => {
  const clipPathId = `payment-error-icon-clip-${useId().replace(/:/g, '')}`

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 88 88'
      fill='none'
      className={className}
      role='img'
      aria-hidden='true'
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d='M43.6706 87.3409C67.789 87.3409 87.3408 67.7891 87.3408 43.6707C87.3408 19.5524 67.789 0.000610352 43.6706 0.000610352C19.5523 0.000610352 0.000488281 19.5524 0.000488281 43.6707C0.000488281 67.7891 19.5523 87.3409 43.6706 87.3409Z'
          fill={color}
        />
        <path
          d='M43.6786 70.4411C45.8931 70.4411 47.6883 68.6459 47.6883 66.4314C47.6883 64.2169 45.8931 62.4218 43.6786 62.4218C41.4641 62.4218 39.6689 64.2169 39.6689 66.4314C39.6689 68.6459 41.4641 70.4411 43.6786 70.4411Z'
          fill='white'
        />
        <path
          d='M43.6615 16.9004C43.2931 19.3478 43.9531 19.8599 43.9567 30.4112C43.9604 40.9626 46.1497 55.1092 43.6747 55.1101C41.1997 55.1109 40.2944 25.9153 31.7002 23.3313C21.5957 20.2932 44.8538 8.97753 43.6615 16.9004Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width='88' height='88' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaymentErrorIcon
